/**
 * Pages that share one menu entry. Each stays its own route (bookmarks and
 * deep links keep working); the layout shows a tab bar to switch between them
 * and the sidebar highlights the shared entry on all of them.
 */
export const SECTIONS = [
    {
        tabs: [
            { to: "/stopwatch", label: "Stoppuhr" },
            { to: "/countdown", label: "Countdown" },
            { to: "/sandbox", label: "Sandbox" },
        ],
    },
    {
        tabs: [
            { to: "/chatlogs", label: "Chat-Log" },
            { to: "/events", label: "Event-Historie" },
        ],
    },
    {
        tabs: [
            { to: "/casino-settings", label: "Features" },
            { to: "/admin/casino", label: "Spieler & Punkte" },
        ],
    },
];
export function sectionFor(pathname) {
    return SECTIONS.find((s) => s.tabs.some((t) => t.to === pathname));
}
